import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const loginPageK = {
  dekoEmployee: "login_page.dekoEmployee",
  userProfileisNotValid: "login_page.userProfileisNotValid",
  login: "login_page.login",
  rememberMe: "login_page.rememberMe",
  contactDeko: "login_page.contactDeko",
  loginHere: "login_page.loginHere",
  emailNotFound: "login_page.emailNotFound",
  welcomeBack: "login_page.welcomeBack",
};

export const useLoginPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      dekoEmployee: t(loginPageK.dekoEmployee),
      userProfileisNotValid: t(loginPageK.userProfileisNotValid),
      login: t(loginPageK.login),
      rememberMe: t(loginPageK.rememberMe),
      contactDeko: t(loginPageK.contactDeko),
      loginHere: t(loginPageK.loginHere),
      emailNotFound: t(loginPageK.emailNotFound),
      welcomeBack: t(loginPageK.welcomeBack),
    }),
    [i18n.language]
  );
};